import React from "react";
import { BRAND_SECONDARY_RGB } from "~/brandColors";

interface PaymentVerifiedIconProps {
  width?: number | string;
  height?: number | string;
  color?: string;
  className?: string;
}

const PaymentVerifiedIcon: React.FC<PaymentVerifiedIconProps> = ({
  width = 104,
  height = 92,
  color = BRAND_SECONDARY_RGB,
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 104 92"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      d="M22.875 29.75H37.625C38.7083 29.75 39.6042 29.3958 40.3125 28.6875C41.0208 27.9792 41.375 27.0833 41.375 26C41.375 24.9167 41.0208 24.0208 40.3125 23.3125C39.6042 22.6042 38.7083 22.25 37.625 22.25H22.875C21.7917 22.25 20.8958 22.6042 20.1875 23.3125C19.4792 24.0208 19.125 24.9167 19.125 26C19.125 27.0833 19.4792 27.9792 20.1875 28.6875C20.8958 29.3958 21.7917 29.75 22.875 29.75ZM22.875 49.75H37.625C38.7083 49.75 39.6042 49.3958 40.3125 48.6875C41.0208 47.9792 41.375 47.0833 41.375 46C41.375 44.9167 41.0208 44.0208 40.3125 43.3125C39.6042 42.6042 38.7083 42.25 37.625 42.25H22.875C21.7917 42.25 20.8958 42.6042 20.1875 43.3125C19.4792 44.0208 19.125 44.9167 19.125 46C19.125 47.0833 19.4792 47.9792 20.1875 48.6875C20.8958 49.3958 21.7917 49.75 22.875 49.75ZM22.875 69.75H37.625C38.7083 69.75 39.6042 69.3958 40.3125 68.6875C41.0208 67.9792 41.375 67.0833 41.375 66C41.375 64.9167 41.0208 64.0208 40.3125 63.3125C39.6042 62.6042 38.7083 62.25 37.625 62.25H22.875C21.7917 62.25 20.8958 62.6042 20.1875 63.3125C19.4792 64.0208 19.125 64.9167 19.125 66C19.125 67.0833 19.4792 67.9792 20.1875 68.6875C20.8958 69.3958 21.7917 69.75 22.875 69.75ZM64.75 58.25C65.0833 58.25 65.3958 58.1875 65.6875 58.0625C65.9792 57.9375 66.25 57.75 66.5 57.5L84.875 39.125C85.7083 38.2917 86.1458 37.3958 86.1875 36.4375C86.2292 35.4792 85 34.5833 85 33.75C84.1667 33 83.25 32.625 82.25 32.625C81.25 32.625 80.375 33.0417 79.625 33.875L64.75 48.625L60.25 44.25C59.5 43.5 58.625 43.125 57.625 43.125C56.625 43.125 55.75 43.5 55 44.25C54.25 45 53.875 45.875 53.875 46.875C53.875 47.875 54.25 48.75 55 49.5L63 57.5C63.25 57.75 63.5208 57.9375 63.8125 58.0625C64.1042 58.1875 64.4167 58.25 64.75 58.25ZM8.75 91.75C6.5 91.75 4.52083 90.8958 2.8125 89.1875C1.10417 87.4792 0.25 85.5 0.25 83.25V8.75C0.25 6.41667 1.10417 4.41667 2.8125 2.75C4.52083 1.08333 6.5 0.25 8.75 0.25H95.25C97.5833 0.25 99.5833 1.08333 101.25 2.75C102.917 4.41667 103.75 6.41667 103.75 8.75V83.25C103.75 85.5 102.917 87.4792 101.25 89.1875C99.5833 90.8958 97.5833 91.75 95.25 91.75H8.75ZM8.75 83.25H95.25V8.75H8.75V83.25Z"
      fill={color}
    />
  </svg>
);

export default PaymentVerifiedIcon;
